import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import appStore from '../../../storage/AppStore'
import Input from '../../../ui/Input'
import Phone from '../../../ui/Phone'

const Parent = ({whois, store, country}) => {
  const [required, setRequired] = React.useState(false);
  useEffect(() => {
    if (store['title'] || store['phone_number']) {
      setRequired(true);
    } else {
      setRequired(false);
    }
  }, [store['title'], store['phone_number']]);
  return (
    <>
      <div className='col-12'><b>{whois === 'father'? appStore.tr.father : appStore.tr.mother}</b></div>
      <div className="col-md-6 position-relative">
        <label htmlFor="parent_input_title"
               className="form-label">{appStore.tr.name || 'Аты'}</label>
        <Input id={'parent_input_title'} store={store} prop={'title'} label={appStore.tr.name || 'Аты'} required={required} />
      </div>
      <div className="col-md-6 position-relative">
        <label htmlFor="input_parent_phone" className="form-label">{appStore.tr.phone_number}</label>
        <Phone
          id={'input_parent_phone'}
          country={country || 'kg'} // Default country
          store={store}
          prop={'phone_number'}
          valid={"is_valid_phone_number"}
          required={required}
        />
      </div>
      <hr />
    </>
  );
}

export default observer(Parent);